import { render, staticRenderFns } from "./CompositeDetails.vue?vue&type=template&id=c53fa254&scoped=true"
import script from "./CompositeDetails.vue?vue&type=script&lang=js"
export * from "./CompositeDetails.vue?vue&type=script&lang=js"
import style0 from "./CompositeDetails.vue?vue&type=style&index=0&id=c53fa254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53fa254",
  null
  
)

export default component.exports